export default {
  material: {
    nameMaterial: 'Nombre del material',
    itemNameCode: 'Código de nombre del artículo',
    segment: 'Segmento',
    family: 'Familia',
    Class: 'Clase',
    productServiceCategory: 'Categoría de producto/servicio',
    price: 'Precio estimado en USD',
    isUrgent: 'Urgente',
    replaces: 'Remplaza código de Elipse N°',
    filterManufacturer: "Filtro de Fabricantes",
    manufacturerName: "Nombre del fabricante",
    acronymManufacturer: "Abreviatura del fabricante",
    partNumber: "Número de parte",
    uom: "Unidad de medida",
  },
  manufacturer1: "Fabricante 1",
  manufacturer2: "Fabricante 2",
  enableManufacturer: "Habilitar fabricante 2",
  completeManufacturer: "Antes debe completar la información del fabricante 1",
  collaManufacturerSelected: "Si selecciona al fabricante Colla debe adjuntar un plano",
  seeMore: 'Ver más',
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/createNewMaterials/Stages/infGeneral.js